module.exports = __webpack_public_path__ + "img/header-img-3.37ca7385.png";